export default __webpack_public_path__ + "static/media/Dune-hd-6.3b8fed44.jpg";